import { useTranslations } from "use-intl";

export function useYesOrNo() {
  const t = useTranslations("Common");

  return (value: boolean) => (value ? t("Yes") : t("No"));
}
